import { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { dashboardService } from '../../store/services/dashboard';

interface RevenueData {
  date: string;
  revenue: number;
}

export function RevenueChart() {
  const [data, setData] = useState<RevenueData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await dashboardService.getRevenueChart(30);
        // L'API retourne { revenue: [...], total: ..., period: "..." }
        const revenueData = (response as any).data.revenue || [];
        setData(revenueData);
      } catch (error) {
        console.error('Error fetching revenue data:', error);
        // Mock data for demo
        setData([
          { date: '2024-01-01', revenue: 1200 },
          { date: '2024-01-02', revenue: 1500 },
          { date: '2024-01-03', revenue: 1800 },
          { date: '2024-01-04', revenue: 1600 },
          { date: '2024-01-05', revenue: 2000 },
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-64">Chargement...</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis 
          dataKey="date" 
          tickFormatter={(value) => {
            const date = new Date(value);
            return date.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' });
          }}
        />
        <YAxis 
          tickFormatter={(value) => `${value} TND`}
        />
        <Tooltip 
          formatter={(value: number) => [`${value.toFixed(2)} TND`, 'Revenus']}
          labelFormatter={(label) => {
            const date = new Date(label);
            return date.toLocaleDateString('fr-FR', { 
              day: '2-digit', 
              month: '2-digit', 
              year: 'numeric' 
            });
          }}
        />
        <Line 
          type="monotone" 
          dataKey="revenue" 
          stroke="#004C92" 
          strokeWidth={2}
          dot={{ fill: '#004C92', strokeWidth: 2, r: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
